<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>

                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                            <p>
                                Bandeja de posibles clientes para convertirlos en socios.
                                Revisa y completa datos, clasifica el prospecto
                                y asígnalo a un vendedor o ruta. Úsalo para dar
                                de alta clientes nuevos sin saltarte pasos.</p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Nuevos Prospectos
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Lista, procesa y sincroniza los nuevos <b>socios de negocio</b> previa aprobación ya sea de forma
                    individual y/o bloque.
                </div>
            </div>
            <!-- Header -->
            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                    <app-status-filters [selectedStatusNewBP]="selectedStatuses" [showStatusNewBP]="[1,0,2,3]"
                        [typeFilter]="'master'" (selectionFilterApply)="onFilter()">
                    </app-status-filters>
                    <!-- Title -->
                    <!--<div class="text-3xl font-extrabold tracking-tight">Sol. de Nuevos Clientes</div> -->
                </div>
                <!-- Actions -->
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                    <!-- <button mat-stroked-button color="primary" (click)="onExportButtonPressed()" matTooltip="Exportar">
                  <mat-icon class="text-current" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                  <span>Exportar</span>
              </button> -->
                    <!-- Add button (only icon) -->
                    <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
                        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    </button>
                    <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Glosario">
                        <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                    </button>
                    <mat-menu #filterMenu="matMenu">
                        <button mat-menu-item [matMenuTriggerFor]="statusMenu">
                            <span>Estado</span>
                        </button>
                    </mat-menu>
                    <mat-menu #statusMenu="matMenu">
                        <button mat-menu-item>
                            <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #008000;"></mat-icon>
                            <span>Aprobado</span>
                        </button>
                        <button mat-menu-item>
                            <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #9f9f3d"></mat-icon>
                            <span>Pendiente</span>
                        </button>
                        <button mat-menu-item>
                            <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #ffa500;"></mat-icon>
                            <span>En revisión</span>
                        </button>
                        <button mat-menu-item>
                            <mat-icon svgIcon="heroicons_outline:x-circle" color="warn"></mat-icon>
                            <span>Rechazado</span>
                        </button>
                    </mat-menu>

                    <!-- <button mat-raised-button color="primary" [disabled]="this.dataSource.data.length == 0 || selection.selected.length == 0" (click)="openConfirmSynDialog()">
                  <mat-icon>cached</mat-icon>
                  Sincronizar ERP
              </button> -->
                </div>
            </div>
        </div>

        <div
            class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
            <!-- Main Content (Table and Paginator) -->
            <div class="pt-1 mx-6">
                <!-- Tabla -->
                <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
                    <!-- Header -->
                    <div class="overflow-auto flex-1 dark:bg-gray-900">
                        <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
                            matSortDisableClear multiTemplateDataRows>

                            <!-- Checkbox -->
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef>
                                    <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
                                        [checked]="selection.hasValue()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                                        [aria-label]="checkboxLabel()">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row" style="width: 5px">
                                    <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)"
                                        [disabled]="row.newBusinessPartnerFlag != statusEnum.APPROVED">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="det">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let row" style="width: 5px;">
                                    <button class="h-7 min-h-7 min-w-10 px-2 leading-6" mat-icon-button
                                        (click)="toggleDetails(row)" style="margin-left: 10px;">
                                        <mat-icon class="icon-size-5" [svgIcon]="selectedBP?._id === row._id
                                ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <!-- Cliente -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
                                <td mat-cell *matCellDef="let row" class="text-sm uppercase leading-tight">
                                    {{ row.name }} <br>
                                    <span *ngIf="row.emails?.[0]?.email">{{ row.emails[0].email }} <br></span>
                                    <span style="color: blue;"><i>{{ row.sendERP ? 'Sincronizado' +
                                            (row.externalKeys?.code ? ' - ' + row.externalKeys.code : '') : ''
                                            }}</i></span>
                                </td>
                            </ng-container>

                            <!-- Ruta -->
                            <ng-container matColumnDef="routes">
                                <th mat-header-cell *matHeaderCellDef>Territorio</th>
                                <td mat-cell *matCellDef="let row" class="text-sm leading-tight">
                                    <div *ngIf="getCode(row.routes?.[0]) as code">
                                        <b style="font-size: 12px;">{{ code }}</b>
                                    </div>
                                    {{ row.routes?.[0]?.name }}
                                </td>
                            </ng-container>


                            <!-- Ubicación -->
                            <ng-container matColumnDef="addresses">
                                <th mat-header-cell *matHeaderCellDef>Ubicación</th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-icon color="primary" (click)="openModal(row)"
                                        style="cursor: pointer;">location_on</mat-icon> {{
                                    row.addresses?.[0]?.geolocationPoint?.[0]}}, {{
                                    row.addresses?.[0]?.geolocationPoint?.[1]}}
                                </td>
                            </ng-container>

                            <!-- Date-->
                            <ng-container matColumnDef="usersAprroved">
                                <th mat-header-cell *matHeaderCellDef># de aprobaciones</th>
                                <td mat-cell *matCellDef="let row" class="mat-column-center">
                                    {{ getRowStringDisplayedApproved(row) }}
                                </td>
                            </ng-container>

                            <!-- Date-->
                            <ng-container matColumnDef="createdAt">
                                <th mat-header-cell *matHeaderCellDef>Fecha de creación</th>
                                <td mat-cell *matCellDef="let row">
                                    {{ formatDate(row.createdAt, false)}}
                                </td>
                            </ng-container>

                            <!-- Estado -->
                            <ng-container matColumnDef="newBusinessPartnerFlag">
                                <th mat-header-cell *matHeaderCellDef>Estado</th>
                                <td mat-cell *matCellDef="let row">
                                    @if(row.newBusinessPartnerFlag == statusEnum.APPROVED){
                                    <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #008000;"
                                        matTooltip="Aprobado"></mat-icon>
                                    }

                                    @if(row.newBusinessPartnerFlag == statusEnum.PENDING){
                                    <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #9f9f3d;"
                                        matTooltip="Pendiente"></mat-icon>
                                    }

                                    @if(row.newBusinessPartnerFlag == statusEnum.IN_PROCESS){
                                    <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #ffa500;"
                                        matTooltip="En revisión"></mat-icon>
                                    }

                                    @if(row.newBusinessPartnerFlag == statusEnum.REJECTED){
                                    <mat-icon svgIcon="heroicons_outline:x-circle" color="warn"
                                        matTooltip="Rechazado"></mat-icon>
                                    }
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left">
                                </th>
                                <td mat-cell *matCellDef="let row" class="px-6 py-3 text-left">
                                    <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #actionMenu="matMenu">
                                        <button mat-menu-item (click)="openEditModal(row)">
                                            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                            <span>{{row.newBusinessPartnerFlag == statusEnum.APPROVED ? 'Ver Registro' :
                                                'Editar Registro'}}</span>
                                        </button>
                                    <button mat-menu-item (click)="openApprove(row)" [disabled]="isApproveDisabled(row)">
                                        <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                                        <span>Aprobar/Rechazar</span>
                                    </button>
                                    <button mat-menu-item (click)="openLogModal(row)">
                                        <mat-icon>visibility</mat-icon>
                                        <span>Visualizar logs</span>
                                    </button>
                                    <button mat-menu-item (click)="openConfirmSynCustomer(row)" [disabled]="isSyncDisabled(row)">
                                        <mat-icon>cached</mat-icon>
                                        <span>Sincronizar</span>
                                    </button>

                                    </mat-menu>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="expandedDetail">
                                <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                                    <tr *ngIf="selectedBP?._id === row._id" class="details-row">
                                        <td [attr.colspan]="displayedColumns.length">
                                            <ng-container
                                                *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: row }"></ng-container>
                                        </td>
                                    </tr>
                            </ng-container>

                            <!-- Header Row -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"
                                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

                            <!-- Fila Principal -->
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"
                                [class.table-expanded-row]="selectedBP?._id === row._id"></tr>

                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
                        </table>
                    </div>
                    <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo
                        sentimos, no hay registros para mostrar.
                    </div>
                </div>

                <!-- Paginación debería asignar valor a this.pageSize-->
                <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
                    <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
                        [length]="totalItems" [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
    <ng-template #rowDetailsTemplate let-business>
        <div class="overflow-hidden">
            <div class="flex">
                <form class="flex w-full flex-col">
                    <div class="flex flex-col py-4 px-2 sm:flex-row">
                        <div class="container flex-auto flex-col">
                            <div class="p-2 flex w-full">
                                <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table
                                    [dataSource]="dataSourceDetail" style="table-layout: fixed; width: 100%;" matSort>
                                    <ng-container matColumnDef="username">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Usuario</th>
                                        <td mat-cell *matCellDef="let detail">
                                            <b>{{detail?.username}}</b> <br>
                                            {{detail?.email}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="approve">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
                                        <td mat-cell *matCellDef="let detail">
                                            <span
                                                class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide"
                                                [ngClass]="{
                                                    'bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50': !detail.approve, 
                                                    'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50': detail.approve,}">
                                                <span class="whitespace-nowrap leading-relaxed"> {{detail.approve ?
                                                    'Aprobado' : 'Rechazado'}}</span>
                                            </span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="reason">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Comentario</th>
                                        <td mat-cell *matCellDef="let detail">
                                            {{detail?.reason}}
                                        </td>
                                    </ng-container>

                                    <!-- Header Row -->
                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail"
                                        class="bg-gray-100 dark:bg-gray-900"></tr>
                                    <!-- Fila principal -->
                                    <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail;" class="border-b">
                                    </tr>
                                </table>
                            </div>
                            <div *ngIf="this.dataSourceDetail.data.length === 0"
                                class="p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </ng-template>

    <!-- Filtros -->
    <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="clearFilters()" (onPanelOpened)="onFilterPanelOpened()">
        <app-dates-filters [form]="form" [showDateCreationRange]="true" [loadData]="loadFiltersData"></app-dates-filters>
        <app-configuration-filters [form]="form" [company]="true" [loadData]="loadFiltersData"></app-configuration-filters>
        <app-routes-filters [form]="form" [territory]="true" [loadData]="loadFiltersData"></app-routes-filters>
    </app-filter>
</mat-sidenav-container>

<!-- Modales -->
<ng-template #addModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">{{'GENERAL.CREATE' | transloco}}</h2>
    <mat-dialog-content class="!p-0 !max-h-none">
        <form #createForm="ngForm" class="gap-y-4 flex flex-col">
            <mat-tab-group>
                <mat-tab label="Información general">
                    <!-- Información Básica -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-blue-600">person</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Información Básica
                            </h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <!-- Nombre -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Nombre</mat-label>
                                <input matInput name="name" [(ngModel)]="currentCreateBusinessPartnerNew.name"
                                    required />
                            </mat-form-field>
                               <!-- Nombre Comercial-->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Nombre Comercial</mat-label>
                                <input matInput name="commercialName" [(ngModel)]="currentCreateBusinessPartnerNew.commercialName"/>
                            </mat-form-field>
                            <!-- Email -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Correo Electrónico</mat-label>
                                <input matInput name="email" [(ngModel)]="currentCreateBusinessPartnerNew.email" />
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Tipo Documento</mat-label>
                                <input matInput name="documentType"
                                    [(ngModel)]="currentCreateBusinessPartnerNew.documentType" />
                            </mat-form-field>

                            <!-- Código Legal -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Código Legal</mat-label>
                                <input matInput name="legalCode" [(ngModel)]="currentCreateBusinessPartnerNew.legalCode"
                                    required />
                            </mat-form-field>

                            <!-- Contacto -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Contacto</mat-label>
                                <input matInput name="contact" [(ngModel)]="currentCreateBusinessPartnerNew.contact"
                                    required />
                            </mat-form-field>

                        </div>
                    </div>
                    <!-- Información de Contacto -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-pink-600">phone</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Información de
                                Contacto</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <!-- Teléfono -->
                            <div class="col-span-1">
                                <label class="block text-sm font-medium text-gray-700 mb-2">Teléfono</label>
                                <div class="grid grid-cols-5 gap-2">
                                    <mat-form-field appearance="fill" class="col-span-2">
                                        <mat-label>Código</mat-label>
                                        <mat-select name="phonePrefix"
                                            [(ngModel)]="currentCreateBusinessPartnerNew.phonePrefix">
                                            <mat-option>
                                                <ngx-mat-select-search [(ngModel)]="searchPhone"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="changueOptionsPhone($event, 'N')"
                                                    placeholderLabel="Buscar..."
                                                    noEntriesFoundLabel="No se encontraron resultados">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let phone of listFilterCountryCodes"
                                                [value]="phone.value">{{phone.label}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field appearance="fill" class="col-span-3">
                                        <mat-label>Número</mat-label>
                                        <input matInput name="phone"
                                            [(ngModel)]="currentCreateBusinessPartnerNew.phone" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- Celular -->
                            <div class="col-span-1">
                                <label class="block text-sm font-medium text-gray-700 mb-2">Celular</label>
                                <div class="grid grid-cols-5 gap-2">
                                    <mat-form-field appearance="fill" class="col-span-2">
                                        <mat-label>Código</mat-label>
                                        <mat-select name="mobilePrefix"
                                            [(ngModel)]="currentCreateBusinessPartnerNew.mobilePrefix">
                                            <mat-option>
                                                <ngx-mat-select-search [(ngModel)]="searchMobile"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="changueOptionsPhone($event)"
                                                    placeholderLabel="Buscar..."
                                                    noEntriesFoundLabel="No se encontraron resultados">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let phone of listFilterCountryMobileCodes"
                                                [value]="phone.value">{{phone.label}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field appearance="fill" class="col-span-3">
                                        <mat-label>Número</mat-label>
                                        <input matInput name="mobile"
                                            [(ngModel)]="currentCreateBusinessPartnerNew.mobile" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Grupos y Clasificación -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-teal-600">category</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Grupos y
                                Clasificación</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <!-- Grupo -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Grupo</mat-label>
                                <mat-select name="businessPartnerGroupId"
                                    [(ngModel)]="currentCreateBusinessPartnerNew.businessPartnerGroupId"
                                    (selectionChange)="changeGroup($event.value)">
                                    <mat-option *ngFor="let group of businessGroupList" [value]="group._id">{{
                                        group.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Sub Grupo -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Sub Grupo</mat-label>
                                <mat-select name="businessPartnerSubGroupId"
                                    [(ngModel)]="currentCreateBusinessPartnerNew.businessPartnerSubGroupId">
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchSubGroup"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsSubgroup($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let subgroup of listFilterBusinessSubGroup"
                                        [value]="subgroup._id">{{ subgroup.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- Ubicación y Dirección -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-green-600">location_on</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Ubicación y
                                Dirección</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <!-- País -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>País</mat-label>
                                <mat-select name="locationOneId"
                                    [(ngModel)]="currentCreateBusinessPartnerNew.locationOneId"
                                    (selectionChange)="changeLocationOne($event.value)" required>
                                    <mat-option *ngFor="let location_one of locationOneList"
                                        [value]="location_one._id">{{ location_one.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Departamento -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Departamento</mat-label>
                                <mat-select name="locationTwoId"
                                    [(ngModel)]="currentCreateBusinessPartnerNew.locationTwoId"
                                    (selectionChange)="changeLocationTwo($event.value)" required>
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchLocationTwo"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsLocationTwo($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let location_two of listFilterLocationTwo"
                                        [value]="location_two._id">{{ location_two.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Ciudad -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Ciudad</mat-label>
                                <mat-select name="locationThreeId"
                                    [(ngModel)]="currentCreateBusinessPartnerNew.locationThreeId"
                                    (selectionChange)="changeLocationThree($event.value)">
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchLocationThree"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsLocationThree($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let location_three of listFilterLocationThree"
                                        [value]="location_three._id">{{ location_three.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Distrito -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Colonia/Distrito</mat-label>
                                <mat-select name="locationFourId"
                                    [(ngModel)]="currentCreateBusinessPartnerNew.locationFourId">
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchLocationFour"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsLocationFour($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let location_four of listFilterLocationFour"
                                        [value]="location_four._id">{{ location_four.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mt-4">
                            <!-- Dirección -->
                            <mat-form-field appearance="fill" class="col-span-1 md:col-span-2">
                                <mat-label>Dirección</mat-label>
                                <input matInput name="address" [(ngModel)]="currentCreateBusinessPartnerNew.address"
                                    required />
                            </mat-form-field>

                            @if(!currentCreateBusinessPartnerNew.useGps){
                            <div class="col-span-1 flex items-center justify-center">
                                <!-- useGps -->
                                <mat-slide-toggle [(ngModel)]="currentCreateBusinessPartnerNew.useGps" name="useGps"
                                    color="primary">
                                    Utilizar GPS
                                </mat-slide-toggle>
                            </div>
                            }

                            @if(currentCreateBusinessPartnerNew.useGps){
                            <!-- Latitud -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Latitud</mat-label>
                                <input matInput name="latitude"
                                    [(ngModel)]="currentCreateBusinessPartnerNew.latitude" />
                            </mat-form-field>

                            <!-- Longitud -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Longitud</mat-label>
                                <input matInput name="longitude"
                                    [(ngModel)]="currentCreateBusinessPartnerNew.longitude" />
                            </mat-form-field>

                            <div class="col-span-1 flex items-center justify-center">
                                <!-- useGps -->
                                <mat-slide-toggle [(ngModel)]="currentCreateBusinessPartnerNew.useGps" name="useGps"
                                    color="primary">
                                    Utilizar GPS
                                </mat-slide-toggle>
                            </div>
                            }
                        </div>
                    </div>
                    <!-- Configuración Comercial -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-purple-600">business</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Configuración
                                Comercial</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            <!-- Company -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Compañía</mat-label>
                                <mat-select [(ngModel)]="currentCreateBusinessPartnerNew.companyId" name="companyId"
                                    required>
                                    @for (company of companyList; track company) {
                                    <mat-option [value]="company._id">
                                        {{ company.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <!-- Tipo de Pago -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Tipo de Pago</mat-label>
                                <mat-select name="typePago" [(ngModel)]="currentCreateBusinessPartnerNew.paymentTypeId">
                                    <mat-option *ngFor="let paymentTypes of paymentTypeList"
                                        [value]="paymentTypes._id">{{ paymentTypes.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Payment condition -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Condición de Pago</mat-label>
                                <mat-select [(ngModel)]="currentCreateBusinessPartnerNew.paymentConditionId"
                                    name="paymentConditionId" required>
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchPaymentCondition"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsPaymentCondition($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @for (payment of listFilterPaymentCondition; track payment) {
                                    <mat-option [value]="payment._id">
                                        {{ payment.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Configuración avanzada">
                    <!-- Información Financiera -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-orange-600">account_balance</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Información
                                Financiera</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <!-- Línea de Crédito -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Línea de Crédito</mat-label>
                                <input matInput name="creditLimit" type="number"
                                    [(ngModel)]="currentCreateBusinessPartnerNew.creditLimit" />
                            </mat-form-field>

                            <!-- Bancos -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Bancos</mat-label>
                                <mat-select name="banco" [(ngModel)]="currentCreateBusinessPartnerNew.bankId">
                                    <mat-option *ngFor="let banks of bankList" [value]="banks._id">{{ banks.name
                                        }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Configuración Logística -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-indigo-600">warehouse</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Configuración
                                Logística</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <!-- Planta -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Planta</mat-label>
                                <mat-select name="plant" [(ngModel)]="currentCreateBusinessPartnerNew.plantId"
                                    (selectionChange)="changePlant($event.value)">
                                    <mat-option *ngFor="let plants of plantList" [value]="plants._id">{{ plants.name
                                        }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Almacén -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Almacén</mat-label>
                                <mat-select name="warehouse" [(ngModel)]="currentCreateBusinessPartnerNew.warehouseId">
                                    <mat-option *ngFor="let warehouses of warehouseList" [value]="warehouses._id">{{
                                        warehouses.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Rutas -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Rutas</mat-label>
                                <mat-select name="subRouteId" [(ngModel)]="currentCreateBusinessPartnerNew.subRouteId"
                                    required>
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchSubRoute"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsSubRoute($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let function of listFilterSubRouteList" [value]="function._id">
                                        <b *ngIf="getCode(function) as code ">{{code}} - </b> {{ function.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                    </div>

                </mat-tab>
            </mat-tab-group>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="modal-actions flex flex-col sm:flex-row justify-between gap-3 px-6 py-4 border-t border-gray-200">
        <button mat-button mat-dialog-close class="order-2 sm:order-1">{{'GENERAL.EXIT' | transloco}}</button>
        <button mat-raised-button color="primary" (click)="createBusinessPartnerNew()" [disabled]="!createForm.valid"
            class="order-1 sm:order-2 w-full sm:w-auto">
            {{'GENERAL.SAVE' | transloco }}
        </button>
    </mat-dialog-actions>
</ng-template>

<!-- Modal Editar -->
<ng-template #editModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
    <mat-dialog-content class="!p-0 !max-h-none">
        <form #editForm="ngForm" class="gap-y-4 flex flex-col">
            <mat-tab-group>
                <mat-tab label="Información general">
                    <!-- Información Básica -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-blue-600">person</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Información Básica
                            </h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <!-- Nombre -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Nombre</mat-label>
                                <input matInput name="name" [(ngModel)]="currentUpdateBusinessPartnerNew.name"
                                    required />
                            </mat-form-field>
                                  <!-- Nombre Comercial-->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Nombre Comercial</mat-label>
                                <input matInput name="commercialName" [(ngModel)]="currentUpdateBusinessPartnerNew.commercialName"/>
                            </mat-form-field>
                            <!-- Email -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Correo Electrónico</mat-label>
                                <input matInput name="email" [(ngModel)]="currentUpdateBusinessPartnerNew.email" />
                            </mat-form-field>

                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Tipo Documento</mat-label>
                                <input matInput name="documentType"
                                    [(ngModel)]="currentUpdateBusinessPartnerNew.documentType" />
                            </mat-form-field>

                            <!-- Código Legal -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Código Legal</mat-label>
                                <input matInput name="legalCode" [(ngModel)]="currentUpdateBusinessPartnerNew.legalCode"
                                    required />
                            </mat-form-field>

                            <!-- Contacto -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Contacto</mat-label>
                                <input matInput name="contact" [(ngModel)]="currentUpdateBusinessPartnerNew.contact"
                                    required />
                            </mat-form-field>

                        </div>
                    </div>
                    <!-- Información de Contacto -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-pink-600">phone</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Información de
                                Contacto</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <!-- Teléfono -->
                            <div class="col-span-1">
                                <label class="block text-sm font-medium text-gray-700 mb-2">Teléfono</label>
                                <div class="grid grid-cols-5 gap-2">
                                    <mat-form-field appearance="fill" class="col-span-2">
                                        <mat-label>Código</mat-label>
                                        <mat-select name="phonePrefix"
                                            [(ngModel)]="currentUpdateBusinessPartnerNew.phonePrefix">
                                            <mat-option>
                                                <ngx-mat-select-search [(ngModel)]="searchPhone"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="changueOptionsPhone($event, 'N')"
                                                    placeholderLabel="Buscar..."
                                                    noEntriesFoundLabel="No se encontraron resultados">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let phone of listFilterCountryCodes"
                                                [value]="phone.value">{{phone.label}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field appearance="fill" class="col-span-3">
                                        <mat-label>Número</mat-label>
                                        <input matInput name="phone"
                                            [(ngModel)]="currentUpdateBusinessPartnerNew.phone" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- Celular -->
                            <div class="col-span-1">
                                <label class="block text-sm font-medium text-gray-700 mb-2">Celular</label>
                                <div class="grid grid-cols-5 gap-2">
                                    <mat-form-field appearance="fill" class="col-span-2">
                                        <mat-label>Código</mat-label>
                                        <mat-select name="mobilePrefix"
                                            [(ngModel)]="currentUpdateBusinessPartnerNew.mobilePrefix">
                                            <mat-option>
                                                <ngx-mat-select-search [(ngModel)]="searchMobile"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="changueOptionsPhone($event)"
                                                    placeholderLabel="Buscar..."
                                                    noEntriesFoundLabel="No se encontraron resultados">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let phone of listFilterCountryMobileCodes"
                                                [value]="phone.value">{{phone.label}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field appearance="fill" class="col-span-3">
                                        <mat-label>Número</mat-label>
                                        <input matInput name="mobile"
                                            [(ngModel)]="currentUpdateBusinessPartnerNew.mobile" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Grupos y Clasificación -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-teal-600">category</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Grupos y
                                Clasificación</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <!-- Grupo -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Grupo</mat-label>
                                <mat-select name="businessPartnerGroupId"
                                    [(ngModel)]="currentUpdateBusinessPartnerNew.businessPartnerGroupId"
                                    (selectionChange)="changeGroup($event.value)">
                                    <mat-option *ngFor="let group of businessGroupList" [value]="group._id">{{
                                        group.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Sub Grupo -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Sub Grupo</mat-label>
                                <mat-select name="businessPartnerSubGroupId"
                                    [(ngModel)]="currentUpdateBusinessPartnerNew.businessPartnerSubGroupId">
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchSubGroup"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsSubgroup($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let subgroup of listFilterBusinessSubGroup"
                                        [value]="subgroup._id">{{ subgroup.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Ubicación y Dirección -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-green-600">location_on</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Ubicación y
                                Dirección</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <!-- País -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>País</mat-label>
                                <mat-select name="locationOneId"
                                    [(ngModel)]="currentUpdateBusinessPartnerNew.locationOneId"
                                    (selectionChange)="changeLocationOne($event.value)" required>
                                    <mat-option *ngFor="let location_one of locationOneList"
                                        [value]="location_one._id">{{ location_one.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Departamento -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Departamento</mat-label>
                                <mat-select name="locationTwoId"
                                    [(ngModel)]="currentUpdateBusinessPartnerNew.locationTwoId"
                                    (selectionChange)="changeLocationTwo($event.value)" required>
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchLocationTwo"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsLocationTwo($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let location_two of listFilterLocationTwo"
                                        [value]="location_two._id">{{ location_two.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Ciudad -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Ciudad</mat-label>
                                <mat-select name="locationThreeId"
                                    [(ngModel)]="currentUpdateBusinessPartnerNew.locationThreeId"
                                    (selectionChange)="changeLocationThree($event.value)">
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchLocationThree"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsLocationThree($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let location_three of listFilterLocationThree"
                                        [value]="location_three._id">{{ location_three.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Distrito -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Colonia/Distrito</mat-label>
                                <mat-select name="locationFourId"
                                    [(ngModel)]="currentUpdateBusinessPartnerNew.locationFourId">
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchLocationFour"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsLocationFour($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let location_four of listFilterLocationFour"
                                        [value]="location_four._id">{{ location_four.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mt-4">
                            <!-- Dirección -->
                            <mat-form-field appearance="fill" class="col-span-1 md:col-span-2">
                                <mat-label>Dirección</mat-label>
                                <input matInput name="address" [(ngModel)]="currentUpdateBusinessPartnerNew.address"
                                    required />
                            </mat-form-field>

                            @if(!currentUpdateBusinessPartnerNew.useGps){
                            <div class="col-span-1 flex items-center justify-center">
                                <!-- useGps -->
                                <mat-slide-toggle [(ngModel)]="currentUpdateBusinessPartnerNew.useGps" name="useGps"
                                    color="primary">
                                    Utilizar GPS
                                </mat-slide-toggle>
                            </div>
                            }

                            @if(currentUpdateBusinessPartnerNew.useGps){
                            <!-- Latitud -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Latitud</mat-label>
                                <input matInput name="latitude"
                                    [(ngModel)]="currentUpdateBusinessPartnerNew.latitude" />
                            </mat-form-field>

                            <!-- Longitud -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Longitud</mat-label>
                                <input matInput name="longitude"
                                    [(ngModel)]="currentUpdateBusinessPartnerNew.longitude" />
                            </mat-form-field>

                            <div class="col-span-1 flex items-center justify-center">
                                <!-- useGps -->
                                <mat-slide-toggle [(ngModel)]="currentUpdateBusinessPartnerNew.useGps" name="useGps"
                                    color="primary">
                                    Utilizar GPS
                                </mat-slide-toggle>
                            </div>

                            }
                        </div>
                    </div>

                    <!-- Configuración Comercial -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-purple-600">business</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Configuración
                                Comercial</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <!-- Company -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Compañía</mat-label>
                                <mat-select [(ngModel)]="currentUpdateBusinessPartnerNew.companyId" name="companyId"
                                    disabled>
                                    @for (company of companyList; track company) {
                                    <mat-option [value]="company._id">
                                        {{ company.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <!-- Tipo de Pago -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Tipo de Pago</mat-label>
                                <mat-select name="typePago" [(ngModel)]="currentUpdateBusinessPartnerNew.paymentTypeId">
                                    <mat-option *ngFor="let paymentTypes of paymentTypeList"
                                        [value]="paymentTypes._id">{{ paymentTypes.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Payment condition -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Condición de Pago</mat-label>
                                <mat-select [(ngModel)]="currentUpdateBusinessPartnerNew.paymentConditionId"
                                    name="paymentConditionId" disabled>
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchPaymentCondition"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsPaymentCondition($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @for (payment of listFilterPaymentCondition; track payment) {
                                    <mat-option [value]="payment._id">
                                        {{ payment.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Configuración avanzada">
                    <!-- Información Financiera -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-orange-600">account_balance</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Información
                                Financiera</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <!-- Línea de Crédito -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Línea de Crédito</mat-label>
                                <input matInput name="creditLimit"
                                    [(ngModel)]="currentUpdateBusinessPartnerNew.creditLimit" />
                            </mat-form-field>

                            <!-- Bancos -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Bancos</mat-label>
                                <mat-select name="banco" [(ngModel)]="currentUpdateBusinessPartnerNew.bankId">
                                    <mat-option *ngFor="let banks of bankList" [value]="banks._id">{{ banks.name
                                        }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Configuración Logística -->
                    <div class="bg-white rounded-lg border border-gray-200 p-4">
                        <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                            <mat-icon class="text-indigo-600">warehouse</mat-icon>
                            <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Configuración
                                Logística</h3>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <!-- Planta -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Planta</mat-label>
                                <mat-select name="plant" [(ngModel)]="currentUpdateBusinessPartnerNew.plantId"
                                    (selectionChange)="changePlant($event.value)">
                                    <mat-option *ngFor="let plants of plantList" [value]="plants._id">{{ plants.name
                                        }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Almacén -->
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Almacén</mat-label>
                                <mat-select name="warehouse" [(ngModel)]="currentUpdateBusinessPartnerNew.warehouseId">
                                    <mat-option *ngFor="let warehouses of warehouseList" [value]="warehouses._id">{{
                                        warehouses.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Rutas / quitar -->
                            @if(false){
                            <mat-form-field appearance="fill" class="col-span-1">
                                <mat-label>Rutas</mat-label>
                                <mat-select name="subRouteId" [(ngModel)]="currentCreateBusinessPartnerNew.subRouteId"
                                    required>
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchSubRoute"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="changueOptionsSubRoute($event)"
                                            placeholderLabel="Buscar..."
                                            noEntriesFoundLabel="No se encontraron resultados">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let function of listFilterSubRouteList" [value]="function._id">
                                        <b *ngIf="getCode(function) as code ">{{code}} - </b> {{ function.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            }
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-between px-6 py-4 border-t border-gray-200">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary"
            (click)="updateBusinessPartnerNew(currentUpdateBusinessPartnerNew._id)" [disabled]="!editForm.valid">
            {{currentUpdateBusinessPartnerNew.newBusinessPartnerFlag == statusEnum.APPROVED ? 'Cerrar' : 'Editar'}}
        </button>
    </mat-dialog-actions>
</ng-template>

<!-- Modal Eliminar -->
<ng-template #deleteDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
                style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">
                Confirmar eliminación
            </h2>
            <mat-dialog-content class="modal-content mt-0">
                <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
        </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
            Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
            Eliminar
        </button>
    </mat-dialog-actions>
</ng-template>

<ng-template #confirmSynDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
                style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">
                Confirmar sincronización
            </h2>
            <mat-dialog-content class="modal-content mt-0">
                <p>¿Está seguro de sincronizar?</p>
            </mat-dialog-content>
        </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
            Cancelar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
            Aceptar
        </button>
    </mat-dialog-actions>



</ng-template>